var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Contentstack from "contentstack";
class ContentStackController {
  constructor() {
    __publicField(this, "_env", {});
    __publicField(this, "_stack");
    this._stack = null;
  }
  configure(stackConfig, environmentVariables) {
    if (!stackConfig.api_key) return;
    this._stack = Contentstack.Stack(stackConfig);
    if (environmentVariables) {
      this._env = environmentVariables;
    }
  }
  setCachePolicy(policy) {
    if (this._stack) {
      this._stack.setCachePolicy(policy);
    } else {
      throw new Error(
        "Cannot set cache policy before stack has been configured. Call Contenstack.configure to setup content stack"
      );
    }
  }
  get stack() {
    if (this._stack) {
      return this._stack;
    } else {
      throw new Error(
        "Cannot access stack before it has been configured. Call Contentstack.configure to setup content stack"
      );
    }
  }
  get env() {
    return this._env;
  }
}
const ContentStack = new ContentStackController();
ContentStack.configure(
  {
    api_key: process.env.CONTENTSTACK_BROWSE_API_KEY,
    branch: process.env.CONTENTSTACK_BROWSE_BRANCH,
    delivery_token: process.env.CONTENTSTACK_BROWSE_DELIVERY_TOKEN,
    environment: process.env.CONTENTSTACK_BROWSE_ENVIRONMENT,
    fetchOptions: {
      retryLimit: 0
    },
    region: process.env.CONTENTSTACK_BROWSE_REGION
  },
  {
    CONTENT_ENTRY_ENVIRONMENT_CLIENT_CONFIGURATION: process.env.CONTENT_ENTRY_ENVIRONMENT_CLIENT_CONFIGURATION,
    CONTENT_ENTRY_ID_CLIENT_CONFIGURATION: process.env.CONTENT_ENTRY_ID_CLIENT_CONFIGURATION
  }
);
const ContentStackLivePreview = new ContentStackController();
ContentStackLivePreview.configure({
  api_key: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_API_KEY,
  branch: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_BRANCH,
  delivery_token: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_DELIVERY_TOKEN,
  environment: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_ENVIRONMENT,
  live_preview: {
    enable: true,
    host: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_PREVIEW_HOST,
    preview_token: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_PREVIEW_TOKEN
  },
  region: process.env.NEXT_PUBLIC_CONTENTSTACK_BROWSE_REGION
});
const ContentStackAccounts = new ContentStackController();
ContentStackAccounts.configure(
  {
    api_key: process.env.CONTENTSTACK_ACCOUNT_API_KEY,
    branch: process.env.CONTENTSTACK_ACCOUNT_BRANCH,
    delivery_token: process.env.CONTENTSTACK_ACCOUNT_DELIVERY_TOKEN,
    environment: process.env.CONTENTSTACK_ACCOUNT_ENVIRONMENT,
    fetchOptions: {
      retryLimit: 0
    },
    region: process.env.CONTENTSTACK_ACCOUNT_REGION
  },
  {
    CONTENT_ENTRY_ENVIRONMENT_CLIENT_CONFIGURATION: process.env.CONTENT_ENTRY_ENVIRONMENT_CLIENT_CONFIGURATION,
    CONTENT_ENTRY_ID_CLIENT_CONFIGURATION: process.env.CONTENT_ENTRY_ID_CLIENT_CONFIGURATION
  }
);
export {
  ContentStack,
  ContentStackAccounts,
  ContentStackLivePreview
};
